<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="false"
  [draggableDialog]="dialog"
  [modal]="true"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{title}} </p-header>
  <div>
    <p *ngIf="messages.length==1">{{messages[0]}}</p>
    <p *ngIf="subMessage!=null">{{subMessage}}</p>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <span class="restart_countdown_label">Restarting in</span>
    <span class="restart_countdown_value">{{countdown}}</span>
    <span class="restart_countdown_seconds">seconds</span>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionRestart()"
      label="{{restartLabel}}"
    ></button>
  </p-footer>
</p-dialog>
